import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const HistoryPage = lazy(() => import('./pages/History'));

/** Histórico e documentos do paciente (T-15). */
const routes: RouteObject[] = [
  { path: '/historico', element: <RequireAuth registered><HistoryPage /></RequireAuth> },
];
export default routes;
